import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaHandshake } from "react-icons/fa6";
import Clients from "./index";
import ViewClient from "./view";
import EditClient from "./edit";

import clientTeamRoutes from "./teams/routes";
import clientSettingRoutes from "./settings/routes";
import clientUserRoutes from "./users/routes";
import { MODULE_CLIENT } from "variables/constants";

const clientRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Clients",
		basePath: "clients",
		mainComponent: <Clients />,
	    layout: "/console",
		icon: <FaHandshake className="icon-item" />,
	    subTitle:"Client",
	    viewComponent: <ViewClient />,
	    createComponent: <EditClient />,
	    editComponent: <EditClient />,
		level:3,
		moduleId: MODULE_CLIENT,
	    viewSubmodules: [
			...clientTeamRoutes,
			...clientUserRoutes,
			...clientSettingRoutes,
		]
	})
];

export default clientRoutes;